module.exports = __webpack_public_path__ + "static/img/manual-19.c839067.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-19.png
// module id = S906
// module chunks = 4